import React from 'react';
import { useParams } from 'react-router-dom';

const ServiceDetail = () => {
    const { name } = useParams(); // URL se service ka naam milega
    return (
        <div className="pt-32 text-center">
            <h1>Service Page: {name.toUpperCase().replace(/-/g, ' ')}</h1>
            <p>Yahan is service ki puri jankari aayegi.</p>
        </div>
    );
};
export default ServiceDetail;